import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import { MyTransition } from './splide-transition';

const commonGalleryOptions = {
    accessibility: true,
    drag: true,
    // @ts-ignore
    pagination: true,
    // @ts-ignore
    slideFocus: false,
    easing: 'linear',
    speed: 600,
    interval: 5000,
    focus: 0,
    gap: '2rem',
    padding: {
        left: '0rem',
        right: '0rem'
    },
    arrows: true,
    keyboard: 'focused',
    video: {
        // setting to true is currently required due to a bug in the splide video extension creating
        // the embed url with an empty "playlist" parameter which break YouTube embed link
        loop: true
    },
    classes: {
        pagination: 'splide__pagination gallery-pagination gallery-pagination-nums',
        page: 'splide__pagination__page gallery-page'
    },

}


const galleryOptions = (perPage: number) => ({
    perPage: perPage,
    perMove: perPage,
    breakpoints: {
        1280: {
            perPage: perPage <= 2 ? perPage : 2,
            perMove: perPage <= 2 ? perPage : 2,
            gap: '1.5rem',
        },
        768: {
            perPage: 1,
            perMove: 1,
            gap: '1rem',
        }
    },
    updateOnMove: true,
    autoHeight: true,
    type: 'loop',

})

const galleryOptionsWithAdjacent = (perPage: number) => ({
    perPage: 1,
    perMove: 1,
    focus: 'center',
    updateOnMove: true,
    autoHeight: true,
    type: 'loop',
    gap: '1.5rem',
    padding: {
        left: '27.5%',
        right: '27.5%'
    },
    trimSpace : false,
    breakpoints: {
        768: {
            padding: {
                left: '15%',
                right: '15%'
            },
        },
        640: {
            gap: '1.5rem',
            padding: {
                left: '1.5rem',
                right: '1.5rem'
            },
        }
    }
})


// Ignore the typescript issues on the pagination property and slideFocus, it's just incorrect typings from the library
export class Gallery {
    gallery: Splide;
    galleryType: string;
    galleryOptions: any;//Refer to splide options documentationt for available choices
    autoStart: string;
    setInterval: string;
    progressBar: HTMLElement;
    galleryElement: HTMLElement;
    constructor(element: HTMLElement) {
        this.galleryElement = element;
        this.galleryType = element.getAttribute('data-gallery-type');
        this.autoStart = element.getAttribute('data-autoplay') != null ? element.getAttribute('data-autoplay') : "";
        // This needs to be set to a obscenely large number due to an interval bug with Splide
        this.setInterval = element.getAttribute('data-interval') != null ? element.getAttribute('data-interval') : "1000000";
        this.setGalleryOptions();
        this.gallery = new Splide(element, this.galleryOptions);
        this.gallery.on('mounted', () => {
            this.arrowDisplay();

            setTimeout(() => {
                const playButtons = Array.prototype.slice.call(this.gallery.root.querySelectorAll('.media-gallery-item .splide__slide__container--has-video'));
                playButtons.forEach(playButton => {
                    const slide = playButton.closest('.splide__slide');
                    const slideTarget = slide.querySelector('[data-gallery-video]');
                    slideTarget.append(playButton);
                });
            }, 1000);//Forgive me, but no event to listen to find out when the playbuttons are loaded. Splide also isn't respecting the splide__slide__container for the playbutton target so I had to do it manually here :(
        });
        this.gallery.on('resized', () => {
            this.arrowDisplay();
        });
        this.gallery.on('move', () => {
            this.gallery.root.classList.add('moving');

        });
        this.gallery.on('moved', () => {
            this.gallery.root.classList.remove('moving');
        });

        this.gallery.on('video:play', () => {
            const videoSelector = ".is-playing .is-active .splide__video__wrapper";
            const playingVideoElement = document.querySelector(`${videoSelector} video`) || document.querySelector(`${videoSelector} iframe`);
            if (playingVideoElement) {
                playingVideoElement.setAttribute('title', playingVideoElement.closest('[data-video-title]').getAttribute('data-video-title'));
            }

        });

        this.gallery.mount({ Video }, MyTransition);
    }
    
    arrowDisplay = () => {
        const galleryArrows = this.gallery.Components.Arrows.arrows;
        if (galleryArrows.next && galleryArrows.prev) {
            const arrowsShouldBeHidden = galleryArrows.next.hasAttribute('disabled') && galleryArrows.prev.hasAttribute('disabled');
            galleryArrows.next.hidden = arrowsShouldBeHidden;
            galleryArrows.prev.hidden = arrowsShouldBeHidden;

        }
    }
    
    setGalleryOptions = () => {
        const perPage = this.galleryElement != null ? parseInt(this.galleryElement.getAttribute('data-grid-size')) : 4;

        const autoPlayOptions = {
            autoplay: this.autoStart.toString(),
            interval: this.setInterval.toString()
        }

        const isGalleryBlock = this.galleryElement.closest('.gallery-block') != null;

        // Use special configuration for grid sizes 0 and 1 to show adjacent items
        const useAdjacentView = (perPage === 0 || perPage === 1) && isGalleryBlock;
        
        this.galleryOptions = {
            ...commonGalleryOptions,
            ...autoPlayOptions,
            ...(useAdjacentView ? galleryOptionsWithAdjacent(perPage) : galleryOptions(perPage))
        }
    }
}